import UseInView from "./useInView";

const DrawLine = ({ className="", delay=0 }) => {
  const [ref,vis] = UseInView();
  return <div ref={ref} className={className} style={{transform:vis?"scaleX(1)":"scaleX(0)",transformOrigin:"left",transition:`transform 1.2s cubic-bezier(0.16,1,0.3,1) ${delay}s`}}/>;
};

export default DrawLine;